import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const KEY = ["company", "invites"] as const;

export function useInvites() {
  return useQuery({ queryKey: KEY, queryFn: api.listInvites });
}

export function useCreateInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createInvite,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRevokeInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.revokeInvite,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useEmailInvite() {
  return useMutation({
    mutationFn: (v: { code: string; email: string }) => api.emailInvite(v.code, v.email),
  });
}
